
<!--

LISTA DE PESQUISA DE PRODUTOS E PRECOS


URL SOMENTE PRODUTOS ATIVOS


 -->


<script>

import BarList from '../components/bar-list'
import AnexosForm from '../components/anexos-form'
import { getText, formatDate } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            coditem: '',
            descricao: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            showAnexosForm: false,
            offset: false,
            tabelas: [
                {
                    codtabpre: '1',
                    descricao: 'Padrão'
                }
            ],
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        produtos: function () {
            return this.$store.getters.getItemSalesList
        },

        tabelasUsuario: function () {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            let tabelas = this.$store.getters.getTabpreList.length ? this.$store.getters.getTabpreList : []

            if (SysVars.usuarioAdministrador)
              return tabelas

            let tabLiberada = false
            let tabsUsr = []
            if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
              tabsUsr = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco

            tabelas = tabelas.filter((obj) => {
                tabLiberada = false
                tabsUsr.forEach( tabUsr => {
                    if (tabUsr.codtabpre == obj.codtabpre)
                      tabLiberada = true
                })
                return obj.sttabpre == 'A' && tabLiberada
            })

            return tabelas
        },

    },

    methods: {
        handleAnexosForm (coditem, descricao) {
            this.coditem = coditem
            this.descricao = descricao
            this.showAnexosForm = true
        },

        handleMore () {
            this.offset = true
            this.loadData()
        },

        closeForm() {
            this.showAnexosForm = false
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codigo":{"$eq":"' + value + '"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        textST (value) {
            return getText(value, this.metadata.item.stitem)
        },

        getTabDescricao (codtabpre) {
            const tab = (this.tabelasUsuario || []).find(t => t.codtabpre == codtabpre);
            return tab ? tab.descricao : ('Tabela ' + codtabpre);
        },

        renderTabelasUsuario (tabelasItem) {
            //exibe precos conforme tabelas liberadas para o usuario
            let tabs = []
            if (tabelasItem && tabelasItem.length) {
                this.tabelasUsuario.forEach(tabUsr => {
                    tabs = tabs.concat(tabelasItem.filter( tabItem => {
                        return tabItem.codtabpre == tabUsr.codtabpre
                    }))
                })
            }
            return tabs
        },

        async loadData() {
            await this.$store.dispatch('loadTabpre', {})

            let params = { filter: this.filter }
            if (this.offset) {
                params.offset = this.nextPage
            }
            this.$store.dispatch('loadPesquisaProdutosSales', params )
            this.offset = false
        }

    },

    components: {
        BarList, AnexosForm
    },

    created () {
        this.loadData()
        console.log('item-precos-list')
    }

}

</script>

<template>
    <div>
        <div id="list">
            <bar-list
                :refresh-button="true"
                :xls-button="true"
                single-entity=""
                plural-entity="Pesquisa de Produtos e Preços"
                @search="search"
                @refresh="loadData"
                title-search="Pesquise pelo código ou pela descrição do produto">
            </bar-list>

            <div class="default-container nb-card-list">
                <alert v-if="produtos.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="(produto, index) in produtos" :key="produto.coditem || index">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <button type="button" class="nb-card-image" :aria-label="'Gerenciar imagem de ' + produto.descricao"
                                title="Gerenciar imagem" @click="handleAnexosForm(produto.coditem, produto.descricao)">
                                <img v-if="produto.url" :src="produto.url" alt="">
                                <i v-else class="fa fa-camera" aria-hidden="true"></i>
                                <span class="nb-card-image-edit"><i class="fa fa-pencil" aria-hidden="true"></i></span>
                            </button>

                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ produto.descricao }}</h2>
                                </div>
                                <div class="nb-card-code">
                                    Código <strong>{{ produto.codigo || '—' }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions" v-if="renderTabelasUsuario(produto.tabelas_preco.tabelas).length">
                            <div class="nb-price-display">
                                <span class="nb-price-label">{{ getTabDescricao(renderTabelasUsuario(produto.tabelas_preco.tabelas)[0].codtabpre) }}</span>
                                <span class="nb-price-value text-primary">
                                    <small>R$</small> {{ renderTabelasUsuario(produto.tabelas_preco.tabelas)[0].vlr | formatValue(2) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">NCM</span>
                            <strong>{{ produto.ncm || '—' }}</strong>
                        </div>
                        <div class="nb-card-detail">
                            <span class="nb-card-detail-label">Estoque</span>
                            <strong>
                                {{ produto.saldo_estoque !== null && produto.saldo_estoque !== undefined ? produto.saldo_estoque : '—' }}
                                <small v-if="produto.uni">{{ produto.uni }}</small>
                            </strong>
                        </div>
                        <div class="nb-card-detail" v-for="(tab, idx) in renderTabelasUsuario(produto.tabelas_preco.tabelas)" :key="idx">
                            <span class="nb-card-detail-label">{{ getTabDescricao(tab.codtabpre) }}</span>
                            <strong class="text-primary"><small>R$</small> {{ tab.vlr | formatValue(2) }}</strong>
                        </div>
                    </div>
                </article>

                <div class="text-center my-3" v-if="nextPage > 0">
                    <button class="btn btn-outline-primary btn-sm" @click="handleMore()">
                        <i class="fa fa-chevron-down mr-1"></i> Exibir mais produtos
                    </button>
                </div>
            </div>
        </div>

        <anexos-form v-if="showAnexosForm" :params="{ ref: 'item', chaveref: coditem, title: descricao, showform: true }" @closeform="closeForm"></anexos-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-image {
  position: relative;
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.nb-card-image:focus-visible {
  outline: 2px solid #004e94;
  outline-offset: 2px;
}

.nb-card-image > img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.nb-card-image > .fa {
  font-size: 19px;
}

.nb-card-image-edit {
  position: absolute;
  right: -5px;
  bottom: -5px;
  display: flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #004e94;
  border: 2px solid #fff;
  border-radius: 50%;
  font-size: 8px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-price-display {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.nb-price-label {
  font-size: 11px;
  color: #64748b;
}

.nb-price-value {
  font-size: 16px;
  font-weight: 700;
}

.nb-price-value small {
  font-size: 11px;
  font-weight: 500;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-start;
  }

  .nb-price-display {
    align-items: flex-start;
    text-align: left;
  }

  .nb-card-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/item-precos-list.vue